/**
 * 导航头-搜索组件
 */
import React, { Component } from 'react';
import { Input } from 'antd';
import Cookies from 'js-cookie';
import hotPng from './imgs/hot.png';
import './index.less';

const searchHistoryKey = Cookies.get('ez-nav-shared-search-history') || '';

class NavSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
			searchFocus: false,
			keyWord: '',
			searchHotTag: props.data || [],
			searchHistory: searchHistoryKey.length > 0 ? JSON.parse(searchHistoryKey) :[]
    }
  }

	// 输入框聚焦
	navSearchFocus = () => {
		this.setState({
			searchFocus: true,
		})
	}
	// 输入框失焦
	navSearchBlur = () => {
		this.setState({
			searchFocus: false,
		})
	}

	// 输入框内容改变
	searchInputChange = (e) => {
		this.setState({
			keyWord: e.target.value,
		})
	}

	// 搜索查询
	searchQuery = (keyWord) => {
		if(keyWord.length === 0) return;
		const { searchHistory } = this.state;
		const url = `/help?searchTxt=${escape(keyWord)}`;
		window.open(url, '_blank');
		const index = searchHistory.indexOf(keyWord);
		if (index > -1) {
			searchHistory.splice(index, 1);
		} else {
			if (searchHistory.length >= 3) {
				searchHistory.pop()
			}
		}
		searchHistory.unshift(keyWord);
		Cookies.set('ez-nav-shared-search-history', searchHistory);
		this.navSearchBlur();
	}

  render() {
		const { searchFocus, keyWord, searchHotTag, searchHistory } = this.state;
    return (
			<div className='search-container' onMouseLeave={(e) => {
				// 当前元素及子元素都不在鼠标范围内
				if (e.relatedTarget && !e.currentTarget.contains(e.relatedTarget)) {
					this.navSearchBlur();
				}
			}}>
				<div className='search-input-icon' onClick={() => {
					window.monitor && window.monitor.report({textKey: 'website_nav_search', text: keyWord});
					this.searchQuery(keyWord);
				}}></div>
				<Input
					className='search-input' 
					onClick={this.navSearchFocus}
					placeholder={this.props.placeholder || '请输入关键字'}
					onChange={this.searchInputChange}
					value={keyWord}
					onPressEnter={(e) => {
						this.searchQuery(e.target.value);
						window.monitor && window.monitor.report({textKey: 'website_nav_search', text: keyWord});
					}}
				/>
				{keyWord.length > 0 && 
					<div className='search-input-clear' onClick={()=>{
						this.setState({
							keyWord: '',
						})
						window.monitor && window.monitor.report({textKey: 'website_nav_search_clear', text: '清空'});
					}}></div>
				}
				<div className={`global-search-container-panel ${searchFocus ? 'focus': ''}`}>
					<div className="global-search-panel _defult-search-panel">
						{searchHistory.length > 0 &&
							<div>
								<div className="global-search-panel-title">
									历史搜索
									<div
										className='global-search-panel-title-delete'
										onClick={() => {
											Cookies.remove('ez-nav-shared-search-history');
											this.navSearchFocus()
											this.setState({
												searchHistory: [],
											})
											window.monitor && window.monitor.report({textKey: 'website_nav_search_history_clear', text: '清空历史记录'});
										}}
									></div>
								</div>
								<div class="global-search-panel-content">
									{searchHistory.map((item, index) => {
										return <span  
											key={`global-search-panel-conten_${index}`}
											onClick={
											() => {
												this.searchQuery(item);
												window.monitor && window.monitor.report({textKey: 'website_nav_search_history', text: item});
											}}
											class="global-search-panel-content-tag">{item}</span>
									})}
								</div>
							</div>
						}
						{searchHotTag.length > 0 &&
							<div>
								<div className="global-search-panel-title">热门搜索<img className='global-search-panel-title-hot' src={hotPng}/></div>
								<div class="global-search-panel-content">
									{searchHotTag.map((item, index) => {
										return <a
										key={`global-search-panel-content_${index}`}
										href={item.href}
										textkey='website_nav_search_hot' 
										target={item.target || '_blank'}
										class="global-search-panel-content-tag">{item.title}</a>
									})}
								</div>
							</div>
						}
					</div>
				</div>
			</div>
    )
  }
}

export default NavSearch;
 